module.exports = __webpack_public_path__ + "static/15-13e30ea6a0e1889c14284b60b453f1e8.jpg";